import type { ComponentProps, ReactNode } from 'react'

import snootsLogo from '@/customer/assets/snoots-logo.png'
import { PageContainer } from '@/customer/components/page-container'

type PublicPageProps = {
  children?: ReactNode
  className?: string
} & Pick<ComponentProps<typeof PageContainer>, 'headline' | 'center'>

/**
 * Shell for public token pages (currently the booking + booking-cancel
 * flows reached via signed email links). Mirrors the geometry of the
 * portal / registration layouts - Snoots logo header, then a
 * `PageContainer` body - without any of the auth or navigation
 * plumbing, since these pages authenticate off the URL token alone.
 */
export function PublicPage({ children, className, headline, center }: PublicPageProps) {
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <header className="flex w-full items-center justify-center px-6 pt-6 pb-4">
        <img src={snootsLogo} alt="Snoots" className="h-8" />
      </header>
      <main className="flex flex-col px-6 pt-4 pb-12 md:pt-8">
        <PageContainer className={className} headline={headline} center={center}>
          {children}
        </PageContainer>
      </main>
    </div>
  )
}
